module.exports = __webpack_public_path__ + "static/media/logo.e00dbef5.png";